export const finiteNumber = value => typeof value === "number" && Number.isFinite(value);

export function formatMoney(value, currency, language) {
    if (!finiteNumber(value) || typeof currency !== "string" || !/^[A-Z]{3}$/.test(currency)) return null;
    try {
        return new Intl.NumberFormat(language || "en", {style: "currency", currency}).format(value);
    } catch {
        return null;
    }
}
